// extracted by mini-css-extract-plugin
export default {"productFeatured":"ST-z","carousel":"TT-z","slides":"UT-z","slide":"VT-z","slidePartialImage":"WT-z","slideFeatured":"XT-z","zoomMode":"YT-z","fadeIn":"ZT-z","imageSizing":"_T-z"};